import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getRecommendations = async (
  token: string,
  baseUrl: string,
  params = {}
) => {
  try {
    const queryPath = `${baseUrl}/recommendations`;

    const res = await get(token, queryPath, params);
    const deserializedRes = await deserialize(res);

    return {
      meta: res.meta,
      recommendations: deserializedRes
    };
  } catch (err) {
    throw new Error(err);
  }
};
